import React from "react";
import PasswordResetSuccess from "../auth/PasswordResetSuccess";

export default function PasswordResetSuccessPage() {
  return <PasswordResetSuccess />;
}
